import React, { useState, useContext } from "react";
import InfoIcon from "../../../assets/icn/info.png";
import { ModalProvider } from "../../../contexts/StockPageModal";
import Image from "next/image";
import NetProfitCard from "@/elements/CompanyFinCards/NetProfitCard/NetProfitCard";
import RevenueCard from "@/elements/CompanyFinCards/RevenueCard/RevenueCard";
import BalanceSheetCard from "@/elements/CompanyFinCards/BalanceSheetCard/BalanceSheetCard";
import CashFlowCard from "@/elements/CompanyFinCards/CashFlowCard/CashFlowCard";
import { CardTitleBtn } from "@/elements/Button/Button";
import { capitalized } from "@/lib/utils";

const modalData = [
    {
        heading: `Net profit`,
        details: `Net profit is the amount of money your business earns after deducting all operating, interest, and tax expenses over a given period of time`
    },
    {
        heading: `Revenue`,
        details: `Revenue is the total amount of income generated by the sale of goods or services related to the company's primary operations`
    },
    {
        heading: `Cash flow`,
        details: `Cashflow means the net amount of cash and cash equivalents being transferred in and out of the company`
    }
];

const companyFinancialCard = [
    {
        heading: `Net profit`,
        indicator: "NP",
        card: NetProfitCard,
        number: 1
    },
    {
        heading: `Revenue`,
        indicator: "RE",
        card: RevenueCard,
        number: 2
    },
    {
        heading: `Balance sheet`,
        indicator: "balance-sheet",
        card: BalanceSheetCard,
        number: 3
    },
    {
        heading: `Cash flow`,
        indicator: "CF",
        card: CashFlowCard,
        number: 4
    }
];

function CompanyFinancial({ name, symbol, isPaidUserPage }) {
    const modal = useContext(ModalProvider);

    const [compFinIndex, setCompFinIndex] = useState(0);

    const openModalHandler = () => {
        modal.setTitle("Company financials");
        modal.setModalData(modalData);
        modal.setModal(true);
    };

    const handleIndicatorChange = (index) => {
        setCompFinIndex(index);
    };

    const Card = companyFinancialCard[compFinIndex].card;

    return (
        <div className="relative w-full lg:w-[calc(50%-8px)]" id="company_financial">
            <div className="font-Inter text-sm lg:text-base text-black flex flex-row justify-between mx-4 lg:mx-0 mb-4 font-semibold  md:mt-10">
                <div className="flex items-center gap-3 flex-[1_0_0]">
                    <h2 className="mr-4 line-clamp-1">Company financials {!isPaidUserPage && `for ${symbol} Share`}</h2>
                    <button className="w-4 h-4 self-center" onClick={openModalHandler}>
                        <Image src={InfoIcon} alt="info" className="w-4 min-w-4 h-4 self-center" />
                    </button>
                </div>
            </div>
            <div className="rounded-xl border border-[#E5E5E5] mx-4 lg:mx-0 py-3 ">
                <div className="font-Inter text-[12px] flex flex-row items-center justify-start overflow-x-auto no-scrollbar gap-2 lg:gap-3 px-3">
                    {companyFinancialCard?.map((ele, i) => (
                        <CardTitleBtn
                            key={i}
                            active={compFinIndex === i}
                            text={ele.heading}
                            onClick={() => handleIndicatorChange(i)}
                        />
                    ))}
                    <p className="text-[#747474] text-xs font-medium whitespace-nowrap ml-auto">Value in Cr.</p>
                </div>
                <Card
                    number={companyFinancialCard[compFinIndex].number}
                    name={name}
                    indicator={companyFinancialCard[compFinIndex].indicator}
                />
            </div>
        </div>
    );
}

export default CompanyFinancial;
